import {
  createStyles,
  // eslint-disable-next-line no-restricted-imports
  Dialog as MuiDialog,
  DialogProps as MuiDialogProps,
  DialogTitle as MuiDialogTitle,
  Fade,
  FadeProps,
  makeStyles,
  Theme,
} from '@material-ui/core';
import React from 'react';
import { Typography } from './Typography';

const Transition = React.forwardRef<unknown, FadeProps>((props, ref) => {
  return <Fade ref={ref} {...props} />;
});

export interface ModalProps {
  className?: string;
  open: boolean;
  onClose?: MuiDialogProps['onClose'];
  maxWidth?: MuiDialogProps['maxWidth'];
}

export const Dialog: React.FC<ModalProps> = ({ className, open, onClose, maxWidth, children }) => {
  const classes = useModalStyle();
  return (
    <MuiDialog
      className={className}
      PaperProps={{ className: classes.paper }}
      fullWidth
      maxWidth={maxWidth || 'sm'}
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      {open && children}
    </MuiDialog>
  );
};

const useModalStyle = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      borderRadius: 0,
      border: `solid ${theme.palette.grey[500]} 1px`,
    },
    title: {
      fontWeight: 'bold',
    },
  }),
);

export const DialogTitle: React.FC = ({ children }) => (
  <MuiDialogTitle disableTypography>
    <Typography variant='h4' color='secondary'>
      {children}
    </Typography>
  </MuiDialogTitle>
);
